import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/jsfiddle': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M510.6 237.5c45.7 25.3 68.4 74.6 56.8 122.6-12.1 50.4-55.5 86.7-108.2 87.3-84 1-168.1 0.5-252.1 0.5-30.3 0-60.7 0.5-91-0.5-48.1-1.6-91.8-35.9-105.6-81.4-14.1-46.6 2.2-94.6 41.9-124.6 2.5-1.9 4.9-6.5 4.5-9.5-3.7-31.9 7.1-57.7 32.7-76.4 26.3-19.3 55.2-21.6 85.3-9.2 2.4 1 4.6 2.2 7.8 3.7 16.5-27.5 38.1-48.7 65.5-63.9 92.9-51.7 211-8.3 246.8 91.6 5.6 15.5 6.7 32.6 9.1 49.1 0.7 5 1.7 8.2 6.4 10.8zM531.7 394.3c39.3-48.4 22.4-117.7-35.1-144.5-7.4-3.5-9.7-7.7-9.8-15.9-1.9-125.1-132.8-187.1-230.2-132.7-26.1 14.6-46.4 34.9-60.7 61.3-7.6 14.1-11.9 8-22.2 2.5-24.6-13.1-49-12.6-72 3.1-22 15-31.9 36.6-26.4 63 2.4 11.6-0.9 17.1-10.1 23.1-38.2 25.3-53.1 74.9-34.2 116.1 18.4 40.2 51.3 59.7 95.2 60 0.7 0 163.7 0.5 163.7-0.2 56.9 0 113.8 0.6 170.7-0.2 28.9-0.4 53-13.2 71.3-35.7zM444 313.8c-5.8 31.2-34.6 55.1-66.7 55.1-17 0-32.1-6.5-44.1-17.7-27.7-25.7-71.1-75-95.9-93.4-20.1-14.9-42-12.3-60.3 3.8-50 44.1 15.9 121.8 67.1 77.2 4.5-4 7.8-9.5 12.7-12.8 8.2-5.5 20.8-0.9 13.2 10.6-17.4 26.3-49.3 38.2-78.9 29.3-28.9-8.7-48.8-36-48.6-70.2 1.2-22.5 12.4-43.1 35.4-56 22.6-12.6 46.4-13.1 67 2.5 50.8 38.5 75.6 81.7 107.3 101.2 24.6 15.1 54.3 7.4 68.8-17.5 28.8-49.2-34.6-105-78.9-63.5-4 3.7-6.9 8.9-11.4 11.7-11 6.8-17.3-4.1-12.8-10.4 20.7-28.6 50.5-40.4 83.3-28.2 31.4 11.7 49.1 44.4 42.8 78.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/jsfiddle.js
// module id = 905
// module chunks = 0